module.exports = __webpack_public_path__ + "media/packs/images/flags/NE-67d1d834c86be0514292173626a36dde.svg";